import React from "react"
import styles from "./StudentStatusLabel.module.css"
import {StudentStatus} from "types/students"
import {useTranslation} from "react-i18next"
import {useModel} from "hooks/useModel"
import {Tooltip} from "antd"
import moment from "moment"

type Props = {
    status: StudentStatus
    createdAt?: string
}

const DEFAULT_STATUS_COLOR = "#939393"

export function StudentStatusLabel({status: {hexColor = DEFAULT_STATUS_COLOR, name, state}, createdAt}: Props) {
    const {t} = useTranslation(["user"])
    const model = useModel()
    const userDateTimeFormat = model.getUserDateTimeFormat() || "MM/DD/YYYY hh:mm A"

    if (createdAt) {
        return (
            <Tooltip title={moment(createdAt).format(userDateTimeFormat)}>
                <div className={styles.statusContainer}>
                    <span className={styles.status} style={{background: hexColor}}>
                        {`${name} ${state ? `[${t(`user.studentStateType.${state}`)}]` : ""}`}
                    </span>
                </div>
            </Tooltip>
        )
    }

    return (
        <div className={styles.statusContainer}>
            <span className={styles.status} style={{background: hexColor}}>
                {`${name} ${state ? `[${t(`user.studentStateType.${state}`)}]` : ""}`}
            </span>
        </div>
    )
}
